import { render, staticRenderFns } from "./WordsFieldReadingEnForm.vue?vue&type=template&id=eb51faa6&scoped=true&lang=pug&"
import script from "./WordsFieldReadingEnForm.vue?vue&type=script&lang=js&"
export * from "./WordsFieldReadingEnForm.vue?vue&type=script&lang=js&"
import style0 from "./WordsFieldReadingEnForm.vue?vue&type=style&index=0&id=eb51faa6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb51faa6",
  null
  
)

export default component.exports